module.exports = __webpack_public_path__ + "img/ad04.cc6a52c7.png";